import Vue from 'vue'

import router from './router'
import store from './store'

import smileVueAlegra from '@alegradev/smile-ui-alegra'
import axios from 'axios'

import App from './App.vue'

axios.defaults.baseURL = process.env.VUE_APP_NODE_ENV === 'dev' ? 'http://localhost:3000/dev' : 'https://api-lending.alegra.com'

// axios.defaults.headers.common.Accept = 'application/json'
axios.defaults.headers.common['Content-Type'] = 'application/json'
// axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
// axios.defaults.headers.common['Access-Control-Allow-Methods'] = '*'
// axios.defaults.headers.common['Access-Control-Allow-Headers'] = 'access-control-allow-headers,access-control-allow-methods,access-control-allow-origin,authorization'

const token = localStorage.getItem('id_token')

if (token) {
  axios.defaults.headers.common.Authorization = `Bearer ${token}`
}

Vue.config.productionTip = false
Vue.use(smileVueAlegra)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
